<template>
  <router-view :key="key" :class="{ '_safari-browser': isSafariBrowser }" />
</template>

<script>
  import {IS_PRODUCTION} from '@/constants/isProduction'
  import globalMetaMixin from '@/mixins/globalMetaMixin'
  import {onIntercomeInteractionStatistic} from "@/services/statistic"
  import {http} from './axios'
  import { isSafari } from './helpers/detectDevice';

  export default {
    mixins: [globalMetaMixin],
    components: {},
    data() {
      return {
        timer: null,
        isHideIntercomLauncher: false,
        isSafariBrowser: false,
      }
    },
    computed: {
      key() {
        return this.$store.state.key
      },
      user() {
        return this.$store.state.user.profile
      },
    },
    methods: {
      setMeta() {
        this.setMetaTitleMixin()
        this.setMetaDescriptionMixin()
      },
      checkIntercom() {
        if (location.host !== 'jobian.com') return
        clearTimeout(this.timer)

        this.timer = setTimeout(() => {
          if (window.innerWidth < 768) {
            if (this.isHideIntercomLauncher) return
            this.$intercom.update({"hide_default_launcher": true})
            this.isHideIntercomLauncher = true
          } else {
            if (!this.isHideIntercomLauncher) return
            this.$intercom.update({"hide_default_launcher": false})
            this.isHideIntercomLauncher = false
          }
        }, 500)
      },
      defineReferralTransition() {
        const url = new URL(document.URL);
        const ref = url.searchParams.get('ref');

        if (ref) {
          http.post('/api/check-reg-hash', { ref });
        }
      },
    },
    created() {
      this.isSafariBrowser = isSafari();

      this.defineReferralTransition();
      // this.setMeta()
    },
    mounted() {
      //INTERCOM
      if (!isRobotAgent && IS_PRODUCTION) {
        setTimeout(() => {
          if (this.user !== null) {
            this.$intercom.boot({
              app_id: 'l4gskfrx',
              name: this.user.fullname,
              email: this.user.email,
            })
          } else {
            this.$intercom.boot({
              app_id: 'l4gskfrx'
            })
          }

          this.$watch('$route', () => {
            this.$intercom.update()
          })

          this.$watch('$intercom.visible', (visible) => {
            if (visible) {
              onIntercomeInteractionStatistic()
            }
          })

          if (window.innerWidth < 768) {
            if (this.isHideIntercomLauncher) return
            this.$intercom.update({"hide_default_launcher": true})
            this.isHideIntercomLauncher = true
          }
          window.addEventListener('resize', this.checkIntercom)
        }, 10000)
      }

      //PRELOADER
      setTimeout(() => {
        const generalPreloader = document.getElementById('general-preloader')
        if (!generalPreloader) return
        generalPreloader.classList.add('_hide')

        setTimeout(() => {
          generalPreloader.parentNode.removeChild(generalPreloader)
        }, 200)
      }, 100)


    },
    watch: {
      '$route.name'(to, from) {
        if(!from) return

        this.setMeta()
      },
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkIntercom)
    }
  }
</script>

<style lang="less">

</style>
